/**
 * G4-T25.8: Çevrimdışı durum banner'ı.
 * navigator.onLine durumunu izler; offline olduğunda uyarı gösterir.
 */
import React, { useState, useEffect } from 'react';

export default function OfflineBanner() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const onOnline  = () => setIsOnline(true);
    const onOffline = () => setIsOnline(false);

    window.addEventListener('online',  onOnline);
    window.addEventListener('offline', onOffline);

    return () => {
      window.removeEventListener('online',  onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div
      role="alert"
      style={{
        background:  'rgba(253, 171, 61, 0.14)',
        color:       '#92400e',
        textAlign:   'center',
        padding:     '6px 16px',
        fontSize:    '0.875rem',
        fontWeight:  500,
        letterSpacing: '0.01em',
      }}
    >
      Çevrimdışı mod — değişiklikler yerel olarak saklanıyor, bağlantı kurulduğunda otomatik gönderilecek.
    </div>
  );
}
